import styles from './drag-and-drop-file.module.scss';
import { useTranslation } from '../../i18n/useTranslation';
import Dropzone from 'react-dropzone';
import { useEffect, useState } from 'react';
import globalStyles from '../../global-styles.module.scss';
import classNames from 'classnames';
import { mainHtmlId } from './drag-and-drop-file.service';

export interface IDragAndDropParam {
    handleFileChange: Function;
    maxWidth: number;
    minHeight: number;
    htmlId: string;
    isValid: boolean;
    uploadFileInfo: string;
    extensionFiles: string[];
    fileNameInput: string | null;
}

const DragAndDropFile: React.FC<IDragAndDropParam> = ({
    handleFileChange,
    maxWidth,
    minHeight,
    htmlId,
    isValid,
    uploadFileInfo,
    extensionFiles,
    fileNameInput,
}): JSX.Element => {
    const { t } = useTranslation('translation');
    const [selectedFiles, setFiles] = useState<File[]>([]);

    useEffect(() => {
        handleFileChange(selectedFiles);
    }, [selectedFiles]);

    const onDrop = (files: File[]) => {
        if (files.length > 0) {
            setFiles(files);
        }
    };

    const getExtensionsName = (): string => {
        let extensionsName: string = '';
        if (Array.isArray(extensionFiles) && extensionFiles.length > 0) {
            extensionsName += '(';
            for (let index = 0; index < extensionFiles.length; index++) {
                index != extensionFiles.length - 1
                    ? (extensionsName += `${extensionFiles[index]}, `)
                    : (extensionsName += extensionFiles[index]);
            }
            extensionsName += ')';
        }
        return extensionsName;
    };

    const getInputName = (): string => {
        return fileNameInput ? fileNameInput : t(uploadFileInfo) + ' ' + getExtensionsName();
    };

    return (
        <>
            <Dropzone onDrop={onDrop} accept={{ extensionFile: extensionFiles }} multiple={false}>
                {({ getRootProps, getInputProps }) => (
                    <section
                        className={`${classNames(globalStyles.flex_center_item, styles.file_content)} ${!isValid ? globalStyles.error_border : ''}`}
                        style={{
                            maxWidth: `${maxWidth}px`,
                            minWidth: `${maxWidth}px`,
                            minHeight: `${minHeight}px`,
                        }}
                    >
                        <div
                            className={classNames(
                                globalStyles.h_100,
                                globalStyles.w_100,
                                globalStyles.flex_center_item,
                                globalStyles.cursor_pointer
                            )}
                            style={{ minHeight: `${minHeight}px` }}
                            {...getRootProps()}
                        >
                            <input {...getInputProps()} id={`${mainHtmlId}-${htmlId}-input`} />
                            {selectedFiles && selectedFiles.length > 0 && selectedFiles[0].name ? (
                                <div>
                                    {selectedFiles && selectedFiles.length > 0 && (
                                        <label className={classNames(globalStyles.cursor_pointer, styles.header_text)}>
                                            {selectedFiles[0].name}
                                        </label>
                                    )}
                                </div>
                            ) : (
                                <label className={classNames(globalStyles.cursor_pointer, styles.header_text)}>
                                    <span className={globalStyles.mr_1}>{getInputName()}</span>
                                </label>
                            )}
                        </div>
                    </section>
                )}
            </Dropzone>
        </>
    );
};

export default DragAndDropFile;
